import '../styles/LoadingSpinner.css'; // Importar los estilos CSS
import logo from '../pictures/logo-its-2.png'; // Importar el logo de la aplicación

const LoadingSpinner = () => {
    return (
        <div className="spinner-container">
            {/* Logo de la aplicación */}
            <img src={logo} alt="Logo de la aplicación" className="app-logo" />

            {/* Spinner */}
            <div className="loading-spinner"></div>

            {/* Nombre de la aplicación */}
            <h1 className="app-name">Cargando componentes...</h1>
        </div>
    );
};

export default LoadingSpinner;